<template>
  <div class="trainee-page">
    <v-card class="trainee-card">
      <div class="trainee-header">
        <div class="trainee-header__copy">
          <div class="trainee-title">Trainees</div>
          <div class="trainee-subtitle">Manage trainee course history and registrations.</div>
        </div>
        <div class="trainee-header__actions">
          <v-btn
              v-if="canCreateTrainee"
              class="trainee-add-button"
              depressed
              @click="goToTraineeRegistration()"
          >
            <v-icon left>mdi-account-plus</v-icon>
            <span>Register trainee</span>
          </v-btn>
        </div>
      </div>

      <v-tabs v-model="tab" class="trainee-tabs" background-color="transparent" color="primary" grow>
        <v-tab v-for="tabItem in tabItems" :key="tabItem">
          {{ tabItem }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="trainee-tabs__content">
        <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
          <existing-trainee v-if="tabItem == 'Trainees from HRA'"/>
          <new-trainee v-if="tabItem == 'Newly Registered Trainees'"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import {TraineeService} from "./trainees.service";
import {getUser} from "@/utils/helper";
import ExistingTrainee from "./existing-trainee/existing-trainee.vue";
import NewTrainee from "@/components/Trainees/new-trainee/new-trainee.vue";

export default {
  props: {
    fromRoute: String,
  },
  components: {
    NewTrainee,
    ExistingTrainee,
  },
  data() {
    return {
      loading: false,
      selected: false,
      items: [],
      title: "",
      hraOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      entries: [],
      CPD_ACTIVITIES: [],
      cpdActLoading: false,
      cpdActivity: null,
      search: null,
      searchDebounce: null,
      filterTrainee: '',
      startMenu: false,
      newTraineeStartMenu: null,
      newTraineeEndMenu: null,
      startDate: '',
      date: '',
      newTraineesSearch: '',
      newTraineesSearchDebounce: null,
      newTraineeStartDate: '',
      endMenu: false,
      endDate: '',
      newTraineeEndDate: '',
      newTraineeSearchDebounce: null,
      searchTrainee: null,
      select: null,
      dialog: false,
      detailDialog: false,
      traineeNotFound: false,
      traineStatusIds: {passId: "", failId: ""},
      traineeStatus: [],
      headers: [
        {text: "Full Name", value: "person.fullName"},
        {text: "Gender", value: "person.gender"},
        // { text: "Birth Date", value: "person.birthdate" },
        // {
        //   text: "Profession",
        //   value: "person.employee_job_history.jobtitlename",
        // },
        {text: "License Number", value: "person.licenseNumber"},
        {text: "Tin Number", value: "person.tin"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      export_fields: {
        "First Name": "person.firstname",
        "Middle Name": "person.middlename",
        "Last Name": "person.lastname",
        Gender: "person.gender",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.courseName" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.continualEducationUnit" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.ceu" : " "),
      },
      export_new_trainee_fields: {
        "First Name": "trainee.firstName",
        "Middle Name": "trainee.middleName",
        "Last Name": "trainee.lastName",
        phoneNumber: "trainee.phoneNumber",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.courseName" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.continualEducationUnit" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.ceu" : " "),
      },
      trainees: [],
      showTable: false,
      trainee: null,
      tab: null,
      tabItems: ["Trainees from HRA", "Newly Registered Trainees"],
      newTraineesSelect: null,
      newTraineeCourseDialog: false,
      newTraineeNotFound: false,
      newTrainee: null,
      newTraineeItems: [],
      newTrainees: [],
      newTraineeSearch: null,
      searchNewTrainee: null,
      newTCourseDetailDialog: false,
      newTraineeheaders: [
        {text: "Full Name", value: "trainee.fullName"},
        {text: "Phone Number", value: "trainee.phoneNumber"},
        {text: "Gender", value: "trainee.gender"},
        {
          text: "Profession",
          value: "trainee.healthProfession.name",
        },
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      historyLoading: false,
      newTraineeLoading: false,
    };
  },
  watch: {
    search(val) {
      if (this.select && this.items.length > 0) return;
      const text = (val || "").toString().trim();
      if (!text) {
        this.traineeNotFound = false;
        return;
      }
      if (text.length < 3) {
        return;
      }
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = null;
      }
      this.searchDebounce = setTimeout(() => {
        val && val !== this.select && this.querySelections(val);
      }, 400);
    },
    options: {
      handler() {
        this.fetchTraineeList();
      },
      deep: true,
    },
    hraOptions: {
      handler() {
        this.fetchTraineeList();
      },
      deep: true,
    },
    filterTrainee: function (val) {
      this.filterTrainee = val;
      this.fetchTraineeList();
    },
    startDate: function (val) {
      if (val == null) {
        this.startDate = ''
      } else {
        this.startDate = val;
        this.fetchTraineeList();
      }
    },
    endDate: function (val) {
      if (val == null) {
        this.endDate = ''
      } else {
        this.endDate = val;
        this.fetchTraineeList();
      }
    },
    newTraineesSearch: function (val) {
      if (this.newTraineesSearchDebounce) {
        clearTimeout(this.newTraineesSearchDebounce);
        this.newTraineesSearchDebounce = null;
      }
      const text = (val || "").toString().trim();
      if (text.length === 0) {
        this.fetchNewTraineeCourseList();
        return;
      }
      if (text.length < 3) {
        return;
      }
      this.newTraineesSearchDebounce = setTimeout(() => {
        this.fetchNewTraineeCourseList();
      }, 400);
    },
    newTraineeStartDate: function (val) {
      if (val == null) {
        this.newTraineeStartDate = ''
      } else {
        this.newTraineeStartDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    newTraineeEndDate: function (val) {
      if (val == null) {
        this.newTraineeEndDate = ''
      } else {
        this.newTraineeEndDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    select(val) {
      val != null
          ? ((this.dialog = true),
              (this.traineeNotFound = false),
              (this.trainee = val))
          : (this.dialog = false);

      this.dialog == true ? (this.title = "Assign Trainee Course") : null;
    },
    newTraineeSearch(val) {
      if (this.newTraineesSelect && this.newTraineeItems.length > 0) return;
      const text = (val || "").toString().trim();
      if (!text) {
        this.newTraineeNotFound = false;
        return;
      }
      if (text.length < 3) {
        return;
      }
      if (this.newTraineeSearchDebounce) {
        clearTimeout(this.newTraineeSearchDebounce);
        this.newTraineeSearchDebounce = null;
      }
      this.newTraineeSearchDebounce = setTimeout(() => {
        val &&
        val !== this.newTraineesSelect &&
        this.newTraineeQuerySelections(val);
      }, 400);
    },
    newTraineesSelect(val) {
      val != null
          ? ((this.newTraineeCourseDialog = true),
              (this.newTraineeNotFound = false),
              (this.newTrainee = val))
          : (this.newTraineeCourseDialog = false);
    },
  },
  computed: {
    fields() {
      if (!this.select) return [];

      return this.select;
    },
    canCreateTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canCreate
      );
    },
    canEditTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canUpdate
      );
    },
    canViewTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canRead
      );
    },
  },
  async beforeMount() {
    if (this.fromRoute === "Back") {
      this.tab = 0;
    } else if (this.fromRoute === "Add") {
      this.tab = 1;
    } else {
      this.tab = 0;
    }
  },
  methods: {
    formatDate(item) {
      const date = new Date(item.birthdate);
      return date;
    },
    viewTrainee(item) {
      this.trainee = item;
      this.detailDialog = true;
      this.title = "Trainee's Course Detail";
    },
    viewNewTrainee(item) {
      this.newTrainee = item;
      this.newTCourseDetailDialog = true;
      this.title = "New Trainee's Course Detail";
    },
    goToTraineeRegistration() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "Add"},
      });
    },
    goToTraineeHistory() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "History"},
      });
    },
    closeDialog(isNewTrainee) {
      this.detailDialog = false;
      this.newTraineeCourseDialog = false;
      this.newTCourseDetailDialog = false;
      this.dialog = false;
      isNewTrainee ? this.fetchNewTraineeCourseList() : this.fetchTraineeList();
    },
    async querySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.items = res.data;

        if (v != null && this.items.length === 0) {
          this.traineeNotFound = true;
        }

        this.items.map((item) => {
          item.fullName =
              item.firstname + " " + item.middlename + " " + item.lastname;
        });
        return this.items;
      } else {
        this.loading = false;

        return this.items;
      }
    },
    async newTraineeQuerySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchNewTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.newTraineeItems = res.data;

        if (v != null && this.newTraineeItems.length === 0) {
          this.newTraineeNotFound = true;
        }

        this.newTraineeItems.map((item) => {
          item.fullName =
              item.firstName + " " + item.middleName + " " + item.lastName;
        });
        return this.newTraineeItems;
      } else {
        this.loading = false;

        return this.newTraineeItems;
      }
    },
    async registerOrUpdateTrainee(trainee) {
      this.historyLoading = true;
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.update(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.create(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    async registerOrUpdateNewTrainee(trainee) {
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.updateNewTraineeCourse(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.createNewTraineeCourse(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    refreshTraineeDetail() {
      this.fetchTraineeList();
      this.fetchNewTraineeCourseList();
      this.fetchTraineeStatus();
    },
    async fetchTraineeStatus() {
      this.traineeStatus = await TraineeService.getTraineeStatus();
      this.traineeStatus.data.filter((e) => {
        this.traineStatusIds.passId =
            e.code == "PASS" ? e.id : this.traineStatusIds.passId;
        this.traineStatusIds.failId =
            e.code == "FAIL" ? e.id : this.traineStatusIds.failId;
      });
    },
    async fetchTraineeList() {
      this.historyLoading = true;
      console.log('here')
      // let dates={}
      // this.startDate!==''&&(dates.startDate=this.startDate);
      // this.endDate!==''&&(dates.endDate=this.endDate);

      const {page, itemsPerPage} = this.hraOptions;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      // this.nonAccCpd !== null && (searchParams += '&trainingCenterId=' + this.nonAccCpd);
      // this.nonAccName !== null && (searchParams += '&name=' + this.nonAccName);
      const res = await TraineeService.getHraTraineeAssignList(params);
      if (res.status === 200) {
        this.trainees = res.data;
      }
      this.historyLoading = false;
    },
    async fetchNewTraineeCourseList() {
      this.newTraineeLoading = true;
      let dates = {}
      this.newTraineeStartDate !== '' && (dates.startDate = this.newTraineeStartDate)
      this.newTraineeEndDate !== '' && (dates.endDate = this.newTraineeEndDate)
      const res = await TraineeService.getNewTraineeCourseListWP(
          this.newTraineesSearch,
          dates
      );
      if (res.status === 200) {
        this.newTrainees = res.data;
      }

      this.newTraineeLoading = false;
    },
    editTrainee(item) {
      this.dialog = true;
      this.trainee = item;
      this.title = "Edit Trainee's Course";
    },
    editNewTrainee(item) {
      this.newTraineeCourseDialog = true;
      this.newTrainee = item;
      this.title = "Edit New Trainee's Course";
    },
  },
};
</script>

<style scoped>
.trainee-page {
  padding: 24px;
  background: #f5f7fb;
  min-height: 100%;
}

.trainee-card {
  border-radius: 0 0 12px 12px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.trainee-header {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto;
  align-items: center;
  gap: 16px;
  padding: 24px 28px;
}

.trainee-header__copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.trainee-header__actions {
  display: flex;
  justify-content: flex-end;
}

.trainee-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
}

.trainee-subtitle {
  font-size: 14px;
  color: #475569;
}

.trainee-add-button {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
}

.trainee-tabs {
  border-top: 1px solid rgba(15, 23, 42, 0.08);
  background: #f8fafc;
  padding: 0 12px;
}

.trainee-tabs__content {
  background: #ffffff;
}

.trainee-tabs ::v-deep .v-tabs-bar {
  background: transparent;
}

.trainee-tabs ::v-deep .v-tab {
  text-transform: none;
  font-weight: 600;
  color: #475569;
}

.trainee-tabs ::v-deep .v-tab--active {
  color: #0f172a;
}

.trainee-tabs ::v-deep .v-tabs-slider {
  background-color: #1976d2;
}

@media (max-width: 700px) {
  .trainee-page {
    padding: 12px;
  }

  .trainee-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
  }

  .trainee-add-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
